import React, {
  useCallback,
  useContext,
  useEffect,
  useMemo,
  useRef,
  useState,
} from "react";
import $ from "jquery";
import "datatables.net-bs4";
import { UserContext } from "../../App";
import { deletePrice, usePrices } from "../../utils/price";
import { verifyRight } from "../../utils/users";
import { StyledTr } from "./bookingContent";
import ActionsMenu from "../layout/ActionsMenu";
import TrashIcon from "../icons/TrashIcon";
import SelectionActionsPopup from "../layout/SelectionActionsPopup";
import { OutlineButtonLink } from "../layout/OutlineButton";

export default function PriceContent() {
  const { userInfos } = useContext(UserContext);
  const [checked, setChecked] = useState([]);
  const { prices, loaded } = usePrices();
  const datatable = useRef(null);

  useEffect(() => {
    if (datatable.current) {
      datatable.current.destroy();
      datatable.current = null;
    }

    window.setTimeout(() => {
      datatable.current = $("#datatable").DataTable({
        retrieve: true,
        order: [[1, "asc"]],
        pageLength: 25,
      });
    }, 1);
  }, [prices, loaded]);

  function handleCheckbox(e) {
    const { value, checked: isChecked } = e.target;

    if (isChecked) {
      setChecked((old) => [...old, value]);
    } else {
      setChecked((old) => old.filter((id) => id !== value));
    }
  }

  const datatableContent = useMemo(() => {
    return (
      <tbody>
        {prices.map((price, index) => {
          let actions = [];
          if (verifyRight(userInfos, "pricing", "update")) {
            actions.push({
              label: "Modifier",
              link: `/price/${price.id}`,
            });
          }

          if (verifyRight(userInfos, "pricing", "delete")) {
            actions.push({
              label: "Supprimer",
              onClick: async () => {
                if (
                  !window.confirm("Voulez-vous vraiment supprimer ce tarif ?")
                )
                  return;

                await deletePrice(userInfos, [price.id]);
                window.location.reload();
              },
            });
          }

          return (
            <StyledTr
              key={price.id}
              className={checked.includes(price.id) ? "checked" : ""}
            >
              <td style={{ textAlign: "center" }}>
                <input
                  type="checkbox"
                  checked={checked.includes(price.id)}
                  name="bulk_action"
                  value={price.id}
                  onChange={handleCheckbox}
                />
              </td>
              <td>{index + 1}</td>
              <td>{price.cityName || "N/A"}</td>
              <td>
                <ActionsMenu items={actions} />
              </td>
            </StyledTr>
          );
        })}
      </tbody>
    );
  }, [prices, userInfos, checked]);

  const handleDeletePrice = useCallback(async () => {
    if (checked.length) {
      if (!window.confirm("Voulez-vous vraiment supprimer ces tarifs ?"))
        return;

      await deletePrice(userInfos, checked);
      window.location.reload();
    }
  }, [checked, userInfos]);

  const PortletFooter = useMemo(() => {
    let actions = [];
    if (verifyRight(userInfos, "pricing", "delete"))
      actions.push({
        label: <TrashIcon />,
        onClick: handleDeletePrice,
      });

    if (checked.length) {
      return (
        <SelectionActionsPopup
          resetChecked={() => setChecked([])}
          selectedItemsLength={checked.length}
          buttons={actions}
          items={[]}
        />
      );
    }
  }, [checked.length, handleDeletePrice, userInfos]);

  if (!loaded) {
    return (
      <div className="kt-content kt-grid__item kt-grid__item--fluid kt-grid kt-grid--hor">
        <div className="kt-container kt-container--fluid kt-grid__item kt-grid__item--fluid">
          <div className="">
            <div className="kt-portlet__body">
              <div className="text-center">Chargement...</div>
            </div>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="body-container">
      <div className="title-container">
        <h3 className="title">Tarifs</h3>
        <div className="header-toolbar">
          {verifyRight(userInfos, "pricing", "create") && (
            <OutlineButtonLink to="/addPrice/">
              <i className="la la-plus"></i>
              Nouveau tarif
            </OutlineButtonLink>
          )}
        </div>
      </div>

      <div>
        <div className="kt-portlet--mobile">
          <div className="kt-portlet__body" style={{ overflowX: "scroll" }}>
            <table
              className="table table-striped- table-bordered table-hover table-checkable"
              id="datatable"
            >
              <thead>
                <tr>
                  <th
                    style={{ width: "5%", textAlign: "center" }}
                    data-sort="false"
                  >
                    Selection
                  </th>
                  <th style={{ width: "5%" }}>#</th>
                  <th style={{ width: "30%" }}>Tarif</th>
                  <th style={{ width: "10%" }}>Actions</th>
                </tr>
              </thead>
              {datatableContent}
            </table>
          </div>
          {PortletFooter}
        </div>
      </div>
    </div>
  );
}
